<template>
  <FormContainer v-if="moduleEnCours?.typeModule === 'Externe'">
    <template #title>Modalité de paiement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          :model-value="moduleEnCours!.avecSubrogation"
          @update:model-value="(value: any) => updateModule('avecSubrogation', activeModuleIndex!, value)"
          label="Paiement direct à l'organisme de formation"
          :items="OuiOuNon"
          :required="metaModuleEnCours?.avecSubrogation?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.avecSubrogation?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
  <FraisFormation
    :frais-data-par-mode
    :readonly
    :nature-frais="store.lov.NatureFrais"
    :modifie-frais
  />
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { FraisFormation } from '@/features/interface/demande/shared'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { ModuleActionKey, type ModuleAction } from '../../useModuleActions'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/CPRO'

  const store = useDemandeCPROStore()

  const { moduleEnCours, metaModuleEnCours, activeModuleIndex, modifieFrais, readonly, fraisDataParMode } =
    inject<ModuleAction>(ModuleActionKey)!

  const { setupArrayUpdaterWithKey } = store

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')
</script>

